var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 87.5,
    r: 87.5,
    fill: "#EEEFF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.5021,
    y: 52.7868,
    width: 61.4979,
    height: 76.2039,
    rx: 4,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.8604,
    y: 62.1452,
    width: 26.0698,
    height: 4.01073,
    rx: 2.00537,
    fill: "#B6BABF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.568,
    y: 114.285,
    width: 34.7597,
    height: 4.01073,
    rx: 2.00537,
    fill: "#B6BABF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.8604,
    y: 80.862,
    width: 42.1127,
    height: 4.01073,
    rx: 2.00537,
    fill: "#B6BABF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67.568,
    y: 71.5036,
    width: 34.7597,
    height: 4.01073,
    rx: 2.00537,
    fill: "#B6BABF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67.8604,
    y: 88.8834,
    width: 24.7329,
    height: 4.01073,
    rx: 2.00537,
    fill: "#B6BABF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67.8604,
    y: 96.9049,
    width: 42.1127,
    height: 4.01073,
    rx: 2.00537,
    fill: "#B6BABF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 44.7653,
    width: 61.4979,
    height: 76.2039,
    rx: 4,
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 58.1237,
    width: 26.0698,
    height: 3,
    rx: 1.5,
    fill: "#B6BABF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 103,
    width: 34.7597,
    height: 3,
    rx: 1.5,
    fill: "#B6BABF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 76,
    width: 42.1127,
    height: 3,
    rx: 1.5,
    fill: "#B6BABF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 67,
    width: 34.7597,
    height: 3,
    rx: 1.5,
    fill: "#B6BABF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 85,
    width: 24.7329,
    height: 3,
    rx: 1.5,
    fill: "#B6BABF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 94,
    width: 42.1127,
    height: 3,
    rx: 1.5,
    fill: "#B6BABF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 52.5021,
    y: 48.7868,
    width: 73.4979,
    height: 88.2039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 45,
    y: 40.7653,
    width: 73.4979,
    height: 88.2039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyView);
export default __webpack_public_path__ + "static/media/empty-view.07ba98c0ab6ef8943c2eb7f5b927d975.svg";
export { ForwardRef as ReactComponent };